"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parseSplitKeyQuery = function (query) {
    if (!query) {
        throw new Error("No split key passed in to splitKey query param");
    }
    return Array.isArray(query) ? query[0] : query;
};
exports.default = parseSplitKeyQuery;
